/* ../src/components/App.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class
} from "svelte/internal";

import { onMount } from "svelte";
import { Tezos } from "@taquito/taquito";
import { TezBridgeWallet } from "@taquito/tezbridge-wallet";
import { ThanosWallet } from "@thanos-wallet/dapp";
import { BeaconWallet } from "@taquito/beacon-wallet";
import { validateAddress } from "@taquito/utils";
import gitHubIcon from "../../public/images/github.svg";
import fileIcon from "../../public/images/file-text.svg";

function add_css() {
	var style = element("style");
	style.id = "svelte-1jmu9bf-style";
	style.textContent = ".faucet.svelte-1jmu9bf.svelte-1jmu9bf{width:60%;margin:0 auto}.navbar-item.svelte-1jmu9bf .icon.svelte-1jmu9bf{margin-right:5px}a.svelte-1jmu9bf.svelte-1jmu9bf{text-decoration:none;color:initial}@media only screen and (max-width: 1024px){.faucet.svelte-1jmu9bf.svelte-1jmu9bf{width:95%}}";
	append(document.head, style);
}

// (209:29) 
function create_if_block_1(ctx) {
	let if_block_anchor;

	function select_block_type_1(ctx, dirty) {
		if (/*balance*/ ctx[4] && /*validAddress*/ ctx[1]) return create_if_block_2;
		if (/*balance*/ ctx[4] === 0 && /*validAddress*/ ctx[1]) return create_if_block_3;
		return create_else_block;
	}

	let current_block_type = select_block_type_1(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (205:10) {#if success}
function create_if_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "The tokens have been successfully added to this account!";
			attr(p, "class", "has-text-success has-text-weight-bold");
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (214:12) {:else}
function create_else_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = " ";
			attr(p, "class", "has-text-white");
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (212:52) 
function create_if_block_3(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "No balance";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (210:12) {#if balance && validAddress}
function create_if_block_2(ctx) {
	let p;
	let t0;
	let t1;
	let t2;

	return {
		c() {
			p = element("p");
			t0 = text("Balance: ");
			t1 = text(/*balance*/ ctx[4]);
			t2 = text(" tokens");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
			append(p, t2);
		},
		p(ctx, dirty) {
			if (dirty & /*balance*/ 16) set_data(t1, /*balance*/ ctx[4]);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let nav;
	let div1;
	let t1;
	let div3;
	let div2;
	let a0;
	let span0;
	let img0;
	let img0_src_value;
	let t2;
	let span1;
	let t4;
	let a1;
	let span2;
	let img1;
	let img1_src_value;
	let t5;
	let span3;
	let t7;
	let section;
	let div14;
	let div13;
	let div5;
	let t12;
	let br1;
	let t13;
	let div12;
	let div7;
	let label;
	let t15;
	let div6;
	let input;
	let t16;
	let t17;
	let br2;
	let t18;
	let div11;
	let div8;
	let button0;
	let t19;
	let button0_disabled_value;
	let t20;
	let div9;
	let button1;
	let t21;
	let button1_disabled_value;
	let t22;
	let div10;
	let button2;
	let t23;
	let button2_disabled_value;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*success*/ ctx[3]) return create_if_block;
		if (!/*success*/ ctx[3]) return create_if_block_1;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type && current_block_type(ctx);

	return {
		c() {
			nav = element("nav");
			div1 = element("div");
			div1.innerHTML = `<div class="navbar-item"><h1 class="title is-5">FA1.2 Token Faucet</h1></div>`;
			t1 = space();
			div3 = element("div");
			div2 = element("div");
			a0 = element("a");
			span0 = element("span");
			img0 = element("img");
			t2 = space();
			span1 = element("span");
			span1.textContent = "Github";
			t4 = space();
			a1 = element("a");
			span2 = element("span");
			img1 = element("img");
			t5 = space();
			span3 = element("span");
			span3.textContent = "Contract";
			t7 = space();
			section = element("section");
			div14 = element("div");
			div13 = element("div");
			div5 = element("div");

			div5.innerHTML = `<h1 class="title is-5">This faucet distributes
          <br>
          100 FA1.2 tokens on Tezos Testnet</h1> 
        <div><p>Input the address of your choice to grant it 100 free tokens. The
            tokens will be added to the ledger present in the token smart
            contract and will be available for transfer to other accounts in the
            smart contract.</p></div>`;

			t12 = space();
			br1 = element("br");
			t13 = space();
			div12 = element("div");
			div7 = element("div");
			label = element("label");
			label.textContent = "Address to receive the free tokens:";
			t15 = space();
			div6 = element("div");
			input = element("input");
			t16 = space();
			if (if_block) if_block.c();
			t17 = space();
			br2 = element("br");
			t18 = space();
			div11 = element("div");
			div8 = element("div");
			button0 = element("button");
			t19 = text("TezBridge Wallet");
			t20 = space();
			div9 = element("div");
			button1 = element("button");
			t21 = text("Beacon Wallet");
			t22 = space();
			div10 = element("div");
			button2 = element("button");
			t23 = text("Thanos Wallet");
			attr(div1, "class", "navbar-brand");
			if (img0.src !== (img0_src_value = gitHubIcon)) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "github-icon");
			attr(span0, "class", "icon is-small svelte-1jmu9bf");
			attr(a0, "class", "navbar-item svelte-1jmu9bf");
			attr(a0, "href", "https://github.com/claudebarde/fa12-testnet-faucet");
			attr(a0, "target", "_blank");
			attr(a0, "rel", "noopener noreferrer");
			if (img1.src !== (img1_src_value = fileIcon)) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "github-icon");
			attr(span2, "class", "icon is-small svelte-1jmu9bf");
			attr(a1, "class", "navbar-item svelte-1jmu9bf");
			attr(a1, "href", "https://better-call.dev/carthagenet/KT1QaxSfGtgn86Lnhtu8PrkApQLiFt2SMEfr/operations");
			attr(a1, "target", "_blank");
			attr(a1, "rel", "noopener noreferrer");
			attr(div2, "class", "navbar-end");
			attr(div3, "class", "navbar-menu");
			attr(nav, "class", "navbar is-fixed-top");
			attr(div5, "class", "box faucet has-text-centered svelte-1jmu9bf");
			attr(label, "for", "address");
			attr(input, "type", "text");
			attr(input, "class", "input");
			attr(input, "id", "address");
			input.disabled = /*loading*/ ctx[2];
			attr(div6, "class", "control");
			toggle_class(div6, "is-loading", /*loading*/ ctx[2]);
			attr(button0, "class", "button is-dark");
			button0.disabled = button0_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2];
			attr(div8, "class", "column is-one-third");
			attr(button1, "class", "button is-info");
			button1.disabled = button1_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2];
			attr(div9, "class", "column is-one-third");
			attr(button2, "class", "button is-warning");
			button2.disabled = button2_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2];
			attr(div10, "class", "column is-one-third");
			attr(div11, "class", "columns has-text-centered");
			attr(div12, "class", "box faucet svelte-1jmu9bf");
			attr(div13, "class", "container");
			attr(div14, "class", "hero-body");
			attr(section, "class", "hero is-fullheight-with-navbar");
		},
		m(target, anchor) {
			insert(target, nav, anchor);
			append(nav, div1);
			append(nav, t1);
			append(nav, div3);
			append(div3, div2);
			append(div2, a0);
			append(a0, span0);
			append(span0, img0);
			append(a0, t2);
			append(a0, span1);
			append(div2, t4);
			append(div2, a1);
			append(a1, span2);
			append(span2, img1);
			append(a1, t5);
			append(a1, span3);
			insert(target, t7, anchor);
			insert(target, section, anchor);
			append(section, div14);
			append(div14, div13);
			append(div13, div5);
			append(div13, t12);
			append(div13, br1);
			append(div13, t13);
			append(div13, div12);
			append(div12, div7);
			append(div7, label);
			append(div7, t15);
			append(div7, div6);
			append(div6, input);
			set_input_value(input, /*address*/ ctx[0]);
			append(div7, t16);
			if (if_block) if_block.m(div7, null);
			append(div12, t17);
			append(div12, br2);
			append(div12, t18);
			append(div12, div11);
			append(div11, div8);
			append(div8, button0);
			append(button0, t19);
			append(div11, t20);
			append(div11, div9);
			append(div9, button1);
			append(button1, t21);
			append(div11, t22);
			append(div11, div10);
			append(div10, button2);
			append(button2, t23);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[9]),
					listen(input, "input", /*isAddressValid*/ ctx[5]),
					listen(button0, "click", /*useTezbridge*/ ctx[6]),
					listen(button1, "click", /*useBeacon*/ ctx[7]),
					listen(button2, "click", /*useThanos*/ ctx[8])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*loading*/ 4) {
				input.disabled = /*loading*/ ctx[2];
			}

			if (dirty & /*address*/ 1 && input.value !== /*address*/ ctx[0]) {
				set_input_value(input, /*address*/ ctx[0]);
			}

			if (dirty & /*loading*/ 4) {
				toggle_class(div6, "is-loading", /*loading*/ ctx[2]);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if (if_block) if_block.d(1);
				if_block = current_block_type && current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div7, null);
				}
			}

			if (dirty & /*validAddress, loading*/ 6 && button0_disabled_value !== (button0_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2])) {
				button0.disabled = button0_disabled_value;
			}

			if (dirty & /*validAddress, loading*/ 6 && button1_disabled_value !== (button1_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2])) {
				button1.disabled = button1_disabled_value;
			}

			if (dirty & /*validAddress, loading*/ 6 && button2_disabled_value !== (button2_disabled_value = !/*validAddress*/ ctx[1] || /*loading*/ ctx[2])) {
				button2.disabled = button2_disabled_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(nav);
			if (detaching) detach(t7);
			if (detaching) detach(section);

			if (if_block) {
				if_block.d();
			}

			mounted = false;
			run_all(dispose);
		}
	};
}

const rpc = "https://carthagenet.smartpy.io";
const fa12Address = "KT1QaxSfGtgn86Lnhtu8PrkApQLiFt2SMEfr";

function instance($$self, $$props, $$invalidate) {
	let address = "";
	let validAddress = false;
	let loading = false;
	let success = false;
	let balance = undefined;

	const isAddressValid = event => {
		const address = event.target.value;

		if (validateAddress(address) === 3) {
			$$invalidate(1, validAddress = true);
		} else {
			$$invalidate(1, validAddress = false);
		}
	};

	const useTezbridge = async () => {
		if (!validAddress) return;
		$$invalidate(2, loading = true);

		// if user chooses TezBridge
		const wallet = new TezBridgeWallet();

		await wallet.setHost(rpc);
		Tezos.setWalletProvider(wallet);

		try {
			const contract = await Tezos.wallet.at(fa12Address);
			const op = await contract.methods.mint(address).send();
			await op.confirmation();
		} catch(error) {
			console.log(error);
		} finally {
			$$invalidate(2, loading = false);
			$$invalidate(4, balance += 100);
			$$invalidate(3, success = true);
			setTimeout(() => $$invalidate(3, success = false), 3000);
		}
	};

	const useBeacon = async () => {
		if (!validAddress) return;
		$$invalidate(2, loading = true);

		// if user chooses Beacon
		const wallet = new BeaconWallet({ name: "FA1.2 Token Faucet" });

		await wallet.requestPermissions({ network: { type: "carthagenet" } });
		Tezos.setWalletProvider(wallet);

		try {
			const contract = await Tezos.wallet.at(fa12Address);
			const op = await contract.methods.mint(address).send();
			await op.confirmation();
		} catch(error) {
			console.log(error);
		} finally {
			$$invalidate(2, loading = false);
			$$invalidate(4, balance += 100);
			$$invalidate(3, success = true);
			setTimeout(() => $$invalidate(3, success = false), 3000);
		}
	};

	const useThanos = async () => {
		if (!validAddress) return;
		$$invalidate(2, loading = true);

		// if user chooses Thanos
		try {
			const available = await ThanosWallet.isAvailable();

			if (!available) {
				throw new Error("Thanos Wallet not installed");
			}

			const wallet = new ThanosWallet("FA1.2 Token Faucet");
			await wallet.connect(rpc.includes("localhost") ? "sandbox" : "carthagenet");
			Tezos.setWalletProvider(wallet);
			const contract = await Tezos.wallet.at(fa12Address);
			const op = await contract.methods.mint(address).send();
			await op.confirmation();
		} catch(err) {
			console.log(err);
		} finally {
			$$invalidate(2, loading = false);
			$$invalidate(4, balance += 100);
			$$invalidate(3, success = true);
			setTimeout(() => $$invalidate(3, success = false), 3000);
		}
	};

	onMount(() => {
		Tezos.setProvider({ rpc });
	});

	function input_input_handler() {
		address = this.value;
		$$invalidate(0, address);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*address*/ 1) {
			$: if (address) {
				if (validateAddress(address) === 3) {
					// loads balance for given address
					Tezos.wallet.at(fa12Address).then(contract => contract.storage()).then(storage => storage.ledger.get(address)).then(account => {
						if (account && account.balance) {
							$$invalidate(4, balance = account.balance.toNumber());
						} else {
							$$invalidate(4, balance = 0);
						}
					}).catch(err => console.log(err));
				}
			}
		}
	};

	return [
		address,
		validAddress,
		loading,
		success,
		balance,
		isAddressValid,
		useTezbridge,
		useBeacon,
		useThanos,
		input_input_handler
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1jmu9bf-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;